import { FC } from 'react';
import { FORECASTING_THEME, STAGE_COLORS } from '../forecastingTheme';
import { formatCurrency, formatPercent } from '../utils/forecastingAggregations';
import { KpiCard, KpiRow } from '../Forecasting.styles';

interface MarginKpiScorecardsProps {
  bookedPlusPipe: number;
  grossProfit: number;
  marginPct: number;
}

export const MarginKpiScorecards: FC<MarginKpiScorecardsProps> = ({
  bookedPlusPipe,
  grossProfit,
  marginPct
}) => (
  <KpiRow>
    <KpiCard as="div" $border={STAGE_COLORS.Booked} style={{ cursor: 'default' }}>
      <div className="label">Booked and Pipe</div>
      <div className="value">{formatCurrency(bookedPlusPipe)}</div>
    </KpiCard>
    <KpiCard as="div" $border={STAGE_COLORS.Pipe} style={{ cursor: 'default' }}>
      <div className="label">Gross Profit</div>
      <div className="value">{formatCurrency(grossProfit)}</div>
    </KpiCard>
    <KpiCard as="div" $border={FORECASTING_THEME.forecast} style={{ cursor: 'default' }}>
      <div className="label">Margin</div>
      <div className="value">{formatPercent(marginPct, 0)}</div>
    </KpiCard>
  </KpiRow>
);
